export enum SHIPPING {
    PACKAGE = 'PAKETVERSAND',
    HAULAGE = 'SPEDITION',
    HEAVY_LOAD = 'SPEDITION_SCHWERLAST',
    HEAVY_LOAD_CURB = 'SPEDITION_BORDSTEINKANTE',
    EXPRESS = 'EXPRESS',
}

export function isShippingHaulage(shippings: string[]): boolean {
    return (
        shippings.includes(SHIPPING.HAULAGE) && !shippings.includes(SHIPPING.HEAVY_LOAD) && !shippings.includes(SHIPPING.HEAVY_LOAD_CURB)
    );
}

export function isShippingHeavyLoad(shippings: string[]): boolean {
    return shippings.includes(SHIPPING.HEAVY_LOAD);
}

export function isShippingHeavyLoadCurb(shippings: string[]): boolean {
    return shippings.includes(SHIPPING.HEAVY_LOAD_CURB);
}

export function isAnySpeditionShipping(shippings: string[]): boolean {
    return shippings.includes(SHIPPING.HAULAGE) || shippings.includes(SHIPPING.HEAVY_LOAD) || shippings.includes(SHIPPING.HEAVY_LOAD_CURB);
}
